import { valueOf2fyebtslgrf1c as valueOf } from '../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/http/HttpHeaders.mjs';
import { startsWith26w8qjqapeeq6 as startsWith } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { flow3tazazxj2t7g4 as flow } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Builders.mjs';
import { onCompletion2zzj1m13j2omp as onCompletion } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Emitters.mjs';
import { _Char___init__impl__6a9atx2gndcvjvc5pke as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { charArrayOf27f4r3dozbrk1 as charArrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/arrays.mjs';
import {
  split3d3yeauc4rm2n as split,
  trim11nh7r46at6sx as trim,
  trim6jpmwojjgb3l as trim_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  isCharSequence1ju9jr1w86plq as isCharSequence,
  isInterface3d6p8outrmvmk as isInterface,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { getOrNull1go7ef9ldk0df as getOrNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { DefaultApolloException8w3ielfxng0h as DefaultApolloException } from '../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import { MultipartReader25md2ukkr9jti as MultipartReader } from './MultipartReader.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/FlowCollector.mjs';
import { initMetadataForLambda3af3he42mmnh as initMetadataForLambda } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Companion_instance1xjg859pd52fi as Companion_instance,
  _Result___init__impl__xyqfz823vatsdepqb9n as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_isGraphQLResponse(_this__u8e3s4) {
  var tmp0_safe_receiver = valueOf(_this__u8e3s4.e49_1, 'Content-Type');
  return (tmp0_safe_receiver == null ? null : startsWith(tmp0_safe_receiver, 'application/graphql-response+json', true)) === true;
}
function get_isMultipart(_this__u8e3s4) {
  var tmp0_safe_receiver = valueOf(_this__u8e3s4.e49_1, 'Content-Type');
  return (tmp0_safe_receiver == null ? null : startsWith(tmp0_safe_receiver, 'multipart/', true)) === true;
}
function multipartBodyFlow(response) {
  var multipartReader = {_v: null};
  var tmp = flow(multipartBodyFlow$slambda_0(multipartReader, response));
  return onCompletion(tmp, multipartBodyFlow$slambda_2(multipartReader));
}
function getBoundaryParameter(contentType) {
  if (contentType == null)
    return null;
  // Inline function 'kotlin.collections.map' call
  var this_0 = split(contentType, charArrayOf([_Char___init__impl__6a9atx(59)]));
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().h2(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.p1();
  while (_iterator__ex2g4s.q1()) {
    var item = _iterator__ex2g4s.r1();
    // Inline function 'kotlin.text.trim' call
    var tmp$ret$2 = toString(trim(isCharSequence(item) ? item : THROW_CCE()));
    destination.i2(tmp$ret$2);
  }
  var parameters = destination;
  var tmp$ret$4;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s_0 = parameters.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var element = _iterator__ex2g4s_0.r1();
      if (startsWith(element, 'boundary=')) {
        tmp$ret$4 = element;
        break $l$block;
      }
    }
    tmp$ret$4 = null;
  }
  var boundaryParameter = tmp$ret$4;
  var tmp1_safe_receiver = boundaryParameter == null ? null : split(boundaryParameter, charArrayOf([_Char___init__impl__6a9atx(61)]));
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : getOrNull(tmp1_safe_receiver, 1);
  return tmp2_safe_receiver == null ? null : trim_0(tmp2_safe_receiver, charArrayOf([_Char___init__impl__6a9atx(34), _Char___init__impl__6a9atx(39)]));
}
var multipartBodyFlow$slambdaClass;
function multipartBodyFlow$slambda() {
  if (multipartBodyFlow$slambdaClass === VOID) {
    class $ {
      constructor($multipartReader, $response) {
        this.l67_1 = $multipartReader;
        this.m67_1 = $response;
      }
      *n67($this$flow, $completion) {
        var tmp = ensureNotNull(this.m67_1.h49());
        var tmp0_elvis_lhs = getBoundaryParameter(valueOf(this.m67_1.e49_1, 'Content-Type'));
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          throw DefaultApolloException().q44('Expected the Content-Type to have a boundary parameter');
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        this.l67_1._v = new (MultipartReader())(tmp, tmp_0);
        $l$loop: while (true) {
          var tmp1_elvis_lhs = ensureNotNull(this.l67_1._v).v66();
          var tmp_1;
          if (tmp1_elvis_lhs == null) {
            break $l$loop;
          } else {
            tmp_1 = tmp1_elvis_lhs;
          }
          var part = tmp_1;
          yield* $this$flow.m1d(part.u66_1, $completion);
        }
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.n67((!(p1 == null) ? isInterface(p1, FlowCollector()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    multipartBodyFlow$slambdaClass = $;
  }
  return multipartBodyFlow$slambdaClass;
}
function multipartBodyFlow$slambda_0($multipartReader, $response) {
  var i = new (multipartBodyFlow$slambda())($multipartReader, $response);
  var l = ($this$flow, $completion) => i.n67($this$flow, $completion);
  l.$arity = 1;
  return l;
}
var multipartBodyFlow$slambdaClass_0;
function multipartBodyFlow$slambda_1() {
  if (multipartBodyFlow$slambdaClass_0 === VOID) {
    class $ {
      constructor($multipartReader) {
        this.o67_1 = $multipartReader;
      }
      *p67($this$onCompletion, it, $completion) {
        // Inline function 'kotlin.runCatching' call
        var tmp;
        try {
          var tmp0_safe_receiver = this.o67_1._v;
          var tmp_0;
          if (tmp0_safe_receiver == null) {
            tmp_0 = null;
          } else {
            tmp0_safe_receiver.l6();
            tmp_0 = Unit_instance;
          }
          // Inline function 'kotlin.Companion.success' call
          var value = tmp_0;
          tmp = _Result___init__impl__xyqfz8(value);
        } catch ($p) {
          var tmp_1;
          if ($p instanceof Error) {
            var e = $p;
            // Inline function 'kotlin.Companion.failure' call
            tmp_1 = _Result___init__impl__xyqfz8(createFailure(e));
          } else {
            throw $p;
          }
          tmp = tmp_1;
        }
        return Unit_instance;
      }
      md(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, FlowCollector()) : false) ? p1 : THROW_CCE();
        return this.p67(tmp, (p2 == null ? true : p2 instanceof Error) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    multipartBodyFlow$slambdaClass_0 = $;
  }
  return multipartBodyFlow$slambdaClass_0;
}
function multipartBodyFlow$slambda_2($multipartReader) {
  var i = new (multipartBodyFlow$slambda_1())($multipartReader);
  var l = ($this$onCompletion, it, $completion) => i.p67($this$onCompletion, it, $completion);
  l.$arity = 2;
  return l;
}
//region block: exports
export {
  get_isGraphQLResponse as get_isGraphQLResponse3ogjhw8yzfes1,
  get_isMultipart as get_isMultipart1je26zsopcnca,
  multipartBodyFlow as multipartBodyFlow272n2l39kgnug,
};
//endregion

//# sourceMappingURL=multipart.mjs.map
